import React from "react";
import { motion } from "framer-motion";

export const SectionHeader = ({ kicker, title, subtitle, align = "left", testId }) => {
  return (
    <motion.div
      data-testid={testId}
      initial={{ opacity: 0, y: 14 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}
    >
      {kicker ? <span className="kicker">{kicker}</span> : null}
      <h2 className="mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl text-maple-navy leading-[1.1] tracking-[-0.01em]">
        {title}
      </h2>
      {subtitle ? (
        <p className="mt-4 text-maple-navy/80 text-base sm:text-lg leading-relaxed">{subtitle}</p>
      ) : null}
    </motion.div>
  );
};

export const Section = ({ id, className = "", children, testId }) => {
  return (
    <section
      id={id}
      data-testid={testId || (id ? `section-${id}` : undefined)}
      className={`relative py-16 sm:py-20 lg:py-24 ${className}`}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative">{children}</div>
    </section>
  );
};
